module.exports = __webpack_public_path__ + "static/media/Emily Patnode Headshot_1665696901708.ced7b4f2.png";